import { render, staticRenderFns } from "./PendenciesFilter.vue?vue&type=template&id=5352548e&scoped=true"
import script from "./PendenciesFilter.vue?vue&type=script&lang=js"
export * from "./PendenciesFilter.vue?vue&type=script&lang=js"
import style0 from "./PendenciesFilter.vue?vue&type=style&index=0&id=5352548e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352548e",
  null
  
)

export default component.exports